import styled from 'styled-components';

export const Divider = styled.div`
  &.horizontal {
    margin: 8px 0;
    border-left: none;
    border-bottom:  1px solid ${({ theme }) => theme.colors.ui03};
    height: 1px;
    &.fullWidth {
      width: 100%;
      margin: 0;
    }
  }
  &.vertical {
    margin: 0 8px;
    width: 1px;
    border-left: 1px solid ${({ theme }) => theme.colors.ui03};
  }
`;

